export default "__VITE_ASSET__xXCZZEbc__"